import classNames from "classnames";
import "./services.scss";

export const Services = () => {
	return (
		<div className={"container"}>
			<h2 className={classNames("subtitle-2", "table-header")}>
				ПРЕЙСКУРАНТ на ортопедические услуги в ИП Горохов М.Ю.
			</h2>
			<table className={"price-table"}>
				<colgroup>
					<col style={{ width: "14%" }} />
					<col style={{ width: "76%" }} />
					<col style={{ width: "8%" }} />
				</colgroup>
  <tbody>
    <tr>
      <td>А16.07.035</td>
      <td>Протезирование частичными съёмными пластиночными протезами (1 челюсть)</td>
      <td>23000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Протезирование частичными съёмными пластиночными протезами с армированием (1 челюсть)</td>
      <td>24000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Протезирование частичными съёмными пластиночными протезами из нейлона (1 челюсть)</td>
      <td>36000,00</td>
    </tr>
    <tr>
      <td>А16.07.023</td>
      <td>Протезирование зубов полными съёмными пластиночными протезами (1 челюсть)</td>
      <td>26000,00</td>
    </tr>
    <tr>
      <td>А16.07.023</td>
      <td>Протезирование зубов полными съёмными пластиночными протезами с армированием (1 челюсть)</td>
      <td>28000,00</td>
    </tr>
    <tr>
      <td>А16.07.023</td>
      <td>Протезирование зубов полными съёмными пластиночными протезами из нейлона (1 челюсть)</td>
      <td>40000,00</td>
    </tr>
    <tr>
      <td>А16.07.036</td>
      <td>Протезирование съёмными бюгельными протезами с замковой фиксацией (1 челюсть)</td>
      <td>67600,00</td>
    </tr>
    <tr>
      <td>А23.07.002.028</td>
      <td>Снятие коронки (цельнометаллической, металлокерамической) 1 единица</td>
      <td>1300,00</td>
    </tr>
    <tr>
      <td>А23.07.002.028</td>
      <td>Снятие штампованной коронки - 1 единица</td>
      <td>800,00</td>
    </tr>
    <tr>
      <td>А16.07.053</td>
      <td>Снятие несъёмной ортопедической конструкции с импланта</td>
      <td>1800,00</td>
    </tr>
    <tr>
      <td>А16.07.092</td>
      <td>Трепанация зуба, трепанация искусственной коронки</td>
      <td>1000,00</td>
    </tr>
    <tr>
      <td>А16.07.049</td>
      <td>Повторная фиксация на постоянный цемент несъёмных ортопедических конструкций (1 единица)</td>
      <td>1300,00</td>
    </tr>
    <tr>
      <td>А16.07.049</td>
      <td>Повторная фиксация на постоянный цемент несъёмных ортопедических конструкций с опорой на имплантах (1 единица)</td>
      <td>1800,00</td>
    </tr>
    <tr>
      <td>А16.07.049</td>
      <td>Временная фиксация ортопедических конструкций (1 единица)</td>
      <td>800,00</td>
    </tr>
    <tr>
      <td>А23.07.002.035</td>
      <td>Приварка кламера</td>
      <td>1500,00</td>
    </tr>
    <tr>
      <td>А23.07.002.036</td>
      <td>Приварка зуба</td>
      <td>1500,00</td>
    </tr>
    <tr>
      <td>А23.07.002.037</td>
      <td>Починка перелома базиса самотвердеющей пластмассой</td>
      <td>2000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Эластичная прокладка для съёмного протеза</td>
      <td>1300,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Полировка пластиночного протеза</td>
      <td>1000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Профессиональная чистка съёмного протеза</td>
      <td>1000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Замена матрицы</td>
      <td>2000,00</td>
    </tr>
    <tr>
      <td>А16.07035</td>
      <td>Искусственная керамическая десна</td>
      <td>3000,00</td>
    </tr>
    <tr>
      <td>А02.07.010.001</td>
      <td>Снятие оттиска с одной челюсти альгинатной массой</td>
      <td>500,00</td>
    </tr>
    <tr>
      <td>А02.07.010.001</td>
      <td>Снятие оттиска с одной челюсти массой из С-силикона</td>
      <td>2300,00</td>
    </tr>
    <tr>
      <td>А16.07.033</td>
      <td>Восстановление зуба с использованием цельнолитой культевой вкладки (1 единица)</td>
      <td>3800,00</td>
    </tr>
    <tr>
      <td>А16.07.033</td>
      <td>Восстановление зуба с использованием культевой вкладки, разборной (1 единица)</td>
      <td>5600,00</td>
    </tr>
    <tr>
      <td>А16.07.033</td>
      <td>Восстановление зуба коронкой временным прямым методом (1 единица)</td>
      <td>900,00</td>
    </tr>
    <tr>
      <td>А16.07.033</td>
      <td>Восстановление зуба коронкой временной композитной фрезерованной лабораторным методом (1ед)</td>
      <td>2900,00</td>
    </tr>
    <tr>
      <td>А23.07.002.028</td>
      <td>Восстановление зуба коронкой постоянной цельнометаллической (1единица)</td>
      <td>9400,00</td>
    </tr>
    <tr>
      <td>А23.07.002.054</td>
      <td>Восстановление зуба коронкой постоянной цельнометаллической с напылением (1 единица)</td>
      <td>10000,00</td>
    </tr>
    <tr>
      <td>А23.07.002.054</td>
      <td>Восстановление зуба коронкой постоянной металлокерамической (1 единица)</td>
      <td>17000,00</td>
    </tr>
    <tr>
      <td>А23.07.002.054</td>
      <td>Восстановление зуба коронкой постоянной безметалловой из диоксида циркония (1 единица)</td>
      <td>28000,00</td>
    </tr>
    <tr>
      <td>А23.07.002.054</td>
      <td>Восстановление зуба коронкой постоянной безметалловой Имакс с индивидуальной эстетикой (метод нанесения) - (1 единица)</td>
      <td>32000,00</td>
    </tr>
    <tr>
      <td>А23.07.002.054</td>
      <td>Восстановление зуба коронкой постоянной безметалловой из диоксида циркония с индивидуальной эстетикой (1 единица)</td>
      <td>33000,00</td>
    </tr>
    <tr>
      <td>А23.07.002.0304</td>
      <td>Изготовление коронки пластмассовой</td>
      <td>2000,00</td>
    </tr>
    <tr>
      <td>А23.07.030</td>
      <td>Использование индивидуальной ложки при снятии оттиска с одной челюсти</td>
      <td>2300,00</td>
    </tr>
    <tr>
      <td>А16.07.036</td>
      <td>Протезирование полными съёмными пластиночными бюгельными протезами с кламмерной фиксацией</td>
      <td>44000,00</td>
    </tr>
    <tr>
      <td>А 23.07.002.03</td>
      <td>Перебазировка съёмного протеза</td>
      <td>1500,00</td>
    </tr>
    <tr>
      <td>А16.07.003</td>
      <td>Восстановление зуба виниром I-MAX</td>
      <td>32000,00</td>
    </tr>
    <tr>
      <td>А16.07.003</td>
      <td>Восстановление зуба виниром I-MAX</td>
      <td>23000,00</td>
    </tr>
    <tr>
      <td>А16.07.036</td>
      <td>Бюгельный протез с кламмерной фиксацией</td>
      <td>52000,00</td>
    </tr>
    <tr>
      <td>А16.07.003</td>
      <td>Восстановление зуба вкладкой из диоксида циркония</td>
      <td>9000,00</td>
    </tr>
    <tr>
      <td>А16.07.054</td>
      <td>Винт</td>
      <td>1300,00</td>
    </tr>
    <tr>
      <td>А16.07.054</td>
      <td>Коронка из диоксида циркония на имплант</td>
      <td>35000,00</td>
    </tr>
    <tr>
      <td>А16.07.054</td>
      <td>Установка формирователя</td>
      <td>8500,00</td>
    </tr>
    <tr>
      <td>А16.07.054</td>
      <td>Снятие слепков с трансфером с одной челюсти</td>
      <td>5000,00</td>
    </tr>
    <tr>
      <td>А16.07.054</td>
      <td>Абатмент</td>
      <td>27000,00</td>
    </tr>
    <tr>
      <td>А16.07.035</td>
      <td>Протезирование частичным съемным протезом (1-3 зуба)</td>
      <td>15000,00</td>
    </tr>
  </tbody>
			</table>
		</div>
	);
};
